<div class="component-wrapper">
  @if (label !== '') {
    <div id="label" [class.invalid]="!valueValid">
      @if (hasValidtor('require')) {
        <span class="reqIcon" id="require" [class.invalid]="!valueValid" #require > * </span>
      }
      <span>{{label}}</span>
      @if (hasValidtor('info')) {
        <mat-icon id="info" #info insTooltip [cfg]="{text: getValidtor('info').displayText, position: {H: 'hCenter', V:'vTop'}, type: 'info'}"
          class="infoIcon" svgIcon="help.tooltip">
        </mat-icon>
      }
    </div>
  }
  <div id="container">
    @if (fileType !== 'image/*' || !showWithImageSelector) {
      <div id = "fileBrowser" >
        <div id="inputFileNotImageContainer" [class.invalid]="!valueValid" [class.disabled]="disabled" [class.filled]="isFilled">
          <input #fileNameBox id="fileSelectionResult" readonly placeholder="{{placeholder}}"
            [value]="getFileName()" insTooltip [cfg]="{text: showTooltip ? (value ? value.name: ghostName) : '', position: {H: 'hCenter', V:'vTop'}, type: 'info'}"/>
            @if (!valueValid) {
              <mat-icon class="warningIcon" svgIcon="alert.err"
                insTooltip [cfg]="{text: getValidtor('input').displayText, position: {H: 'hRight', V:'vBottom'}, type: 'err'}">
              </mat-icon>
            }
          </div>
          <div id="button" [class.disabled]="disabled" (click)="getFile()">{{buttonText}}</div>
        </div>
      } @else {
        <div id = "imageBrowser">
          @if (value && valueValid) {
            <div id="imageContainer">
              <img id="image" [src]="getImageSrc()" alt="img icon">
              <span id="textButtonContainer">
                <label class="textButton" (click)="getFile()">Edit Image</label>
              </span>
            </div>
          } @else {
            <div id="emptyImageContainerContainer">
              <div id="emptyImageContainer" (click)="getFile()">
                <mat-icon svgIcon="input-file.browse" ></mat-icon>
              </div>
              <div id="nonValidIconContainer">
                @if (!valueValid) {
                  <mat-icon class="warningIcon" svgIcon="warning"
                    insTooltip [cfg]="{text: getValidtor('input').displayText, position: {H: 'hRight', V:'vBottom'}, type: 'err'}">
                  </mat-icon>
                }
              </div>
            </div>
          }
        </div>
      }
      <div class="file-uploader" hidden>
        <input #upfile id="upfile" type="file" [accept]="fileType" (change)="onFileChange()">
      </div>
    </div>
  </div>
